export const PENDING = '26e49df2-6977-4d38-8834-4af0012c97d4';
export const CANCELLED = 'd6cd1581-ac20-4420-b93b-64a37cff060c';
export const IMPORTING = '2b33f0b5-432a-47ae-aef4-7ab1e4234247';
export const SCHEDULED = '8278cb5e-5087-41b7-a5f1-c6665430e633';
export const SENDING = 'efe2830d-5823-437a-b5a5-9b56c3fe29c6';
export const SENT = '43f7734e-6bf2-4aeb-a05e-0d70d631cc71';
export const SENT_WITH_ERRORS = '60308b32-b5cc-471e-8a4f-4cff2bbf19e0';
export const SANITIZING = 'ba711104-964a-4402-b103-bf268c9f9cd0';

export interface BroadcastStatus {
  id: string;
  status: string;
}

/**
 * Funções puras (M8 / CU-17tm466nzee) reusadas na lista, no detalhe e no
 * `broadcasts-filter` (m8-voz). Tipadas com a forma mínima do broadcast, não
 * o model `Broadcast` inteiro, para não criar import circular com
 * `Broadcast.ts` (que importa o tipo `BroadcastStatus` daqui).
 */
export interface BroadcastStatusLike {
  broadcast_status_id: string;
}

/**
 * `BroadcastController::update` só aceita broadcast SCHEDULED (óbvio,
 * precisa não ter sido enviado ainda). A condição antiga do front era
 * "importando E agendado" — praticamente nunca verdadeira ao mesmo tempo,
 * por isso o botão Editar nunca aparecia na lista.
 */
export function canEditBroadcast(broadcast: BroadcastStatusLike): boolean {
  return broadcast.broadcast_status_id === SCHEDULED;
}

/**
 * `BroadcastController::cancel` só aceita SCHEDULED ou PENDING; qualquer
 * outro status (SENDING, IMPORTING, SANITIZING, SENT_WITH_ERRORS) devolve
 * 400 "Não é possível cancelar um broadcast que já foi enviado ou está
 * sendo enviado". A condição antiga do front (`!isSent && !isCancelled`)
 * mostrava Cancelar nesses status também, que sempre davam erro.
 */
export function canCancelBroadcast(broadcast: BroadcastStatusLike): boolean {
  return broadcast.broadcast_status_id === SCHEDULED || broadcast.broadcast_status_id === PENDING;
}

/**
 * Mesmos sufixos de `.status-pill--*` que `wa-chips` (`_layout-v2-whatsapp.scss`,
 * trazido idêntico da mg5z) já define — não inventa modificador novo no mixin
 * compartilhado: `ok` (sucesso), `warn` (atenção), `cool` (informativo/em
 * andamento), `ai` (violeta, usado hoje para IA), `danger`.
 */
export type BroadcastStatusTone = 'ok' | 'warn' | 'cool' | 'ai' | 'danger';

/** Cor do status-pill (layout novo), por status. */
export function broadcastStatusTone(statusId: string): BroadcastStatusTone {
  switch (statusId) {
    case SENT:
      return 'ok';
    case SCHEDULED:
    case IMPORTING:
    case SENT_WITH_ERRORS:
      return 'warn';
    case SANITIZING:
      return 'ai';
    case CANCELLED:
      return 'danger';
    case PENDING:
    case SENDING:
    default:
      return 'cool';
  }
}

